import { CommonModule }         from '@angular/common';
import { NgModule }             from '@angular/core';
import { NgbTooltipModule }     from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerComponent } from '@shared/components/color-picker/color-picker.component';
import { ColorCompactModule }   from 'ngx-color/compact';
import { ColorHueModule }       from 'ngx-color/hue';
import { ColorSliderModule }    from 'ngx-color/slider';
import { ColorSwatchesModule }  from 'ngx-color/swatches';

@NgModule( {
	declarations: [
		ColorPickerComponent
	],
	exports: [
		ColorPickerComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Third Party
		ColorCompactModule,
		ColorHueModule,
		ColorSliderModule,
		ColorSwatchesModule,
		NgbTooltipModule
	]
} )
export class ColorPickerModule {}
